<div [formGroup]="form">
    <label [attr.for]="field.key"><strong>{{ field.label }}</strong></label>
    <div>
        @switch (field.controlType) {
            @case ('textbox') {
                <input pInputText
                       [formControlName]="field.key" [id]="field.key"
                       [type]="field.type">
            }
            @case ('dropdown') {
                <p-dropdown
                    *ngIf="!field.completed"
                    [options]="field.options" optionLabel="value" [showClear]="true"
                    [formControlName]="field.key"
                    placeholder="Seleccione"
                    [checkmark]="true"
                    [filter]="true"
                    filterBy="descripcion"
                    [pTooltip]="field.label"
                    tooltipPosition="top"></p-dropdown>
                <div *ngIf="field.completed">
                    @for (va of field.values; track field.values) {
                        <div class="field">
                            <p-tag icon="pi pi-tag" value="{{va.value}}"/>
                        </div>
                    }
                </div>
            }
            @case ('multiselect') {
                <p-multiSelect
                    *ngIf="!field.completed"
                    [options]="field.options" optionLabel="value" [showClear]="true"
                    [formControlName]="field.key"
                    placeholder="Seleccione"
                    [filter]="true"
                    filterBy="descripcion"
                    [pTooltip]="field.label"
                    display="chip"
                    tooltipPosition="top"
                />
                <div *ngIf="field.completed">
                    @for (va of field.values; track field.values) {
                        <div class="field">
                            <p-tag icon="pi pi-tag" value="{{va.value}}"/>
                        </div>
                    }
                </div>
            }
        }
    </div>
    @if (!isValid && !field.completed) {
        <div class="text-small" style="color:red">{{ field.label }} es requerido</div>
    }

</div>
